export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_USER = 'UPDATE_USER';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET = 'RESET';
export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN';
